<div id="photosModal" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
  <div style="background-color: #ffffff;
  margin: 35vh auto;
  padding: 2em;
  border: 1px solid #888;
  width: 80%;
  max-width: 300px;
  border-radius: 1em;
  position: relative">
  <svg  style="position: absolute;
  top: 0.5em;
  right: 0.5em;
  cursor: pointer;
  height: 2.5em;
  color: #4f4f4f;" (click)="closePhotoModal()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
    <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
  </svg>
  
    <p style="color: #424242;font-weight: 600;">View photos, or add extra photos (regarding conditions, communication, etc)?</p>
    <button style="border: 0;
    margin-right: 1em;
    background: #8cc63f;
    color: white;
    width: 6em;
    height: 3em;
    border-radius: 0.25em;" (click)="handleModalResponse(true)">View</button>
    <button style="border: 0;
    background: #ffffff;
    color: #424242;
    width: 5em;
    height: 3em;
    border-radius: 0.25em;" (click)="handleModalResponse(false)">Add</button>
  </div>
</div>

  <div id="viewsubdivisionmodal" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 500px;
    border-radius: 1em;">

      <p style="font-size: 2em;">{{modalSub?.subdivision_name}}</p>
      <p>Elecutility: {{modalSub?.elecutility || 'Not Defined'}}</p>
      <p>Gas Utility: {{modalSub?.gasutility || 'Not Defined'}}</p>
      <p>Elevation: {{modalSub?.elevation|| 'Not Defined'}}</p>
      <p>Scope: {{modalSub?.scope|| 'None Selected'}}</p>
      <div style="border: 1px dotted;
    padding: 1em;">
      <p>Consultant: {{modalSub?.consultant_name|| 'No Consultant'}}</p>
      <p>{{modalSub?.consultant_phone}}</p>
      <p>{{modalSub?.consultant_email}}</p>
      </div>
      <p>Area Manager Email: {{modalSub?.areamanemail || 'Not defined'}}</p>
      <p>Lat-Lng: {{modalSub?.lat}},{{modalSub?.lng}}</p>
      <button style="
    margin-top: 2em;
    height: 4em;
    background: #8BC34A;
    color: #ffffff;
    width: 8em;
    border: 1px solid #d8d8d8;
    border-radius: 0.5em;
     " (click)="closeSubDivModal()">Close
      </button>
    </div>
  </div>



<div>
  <div class="titleBox">
    <div class="loadingOverlay" [hidden]="!(isLoading || dayListPending)" >

      <div style="position: absolute;
      /* padding-top: 25%; */
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);">
        <p class="loadingText">Loading Jobs...</p>

        <mat-spinner style="margin: auto; color:white !important;"></mat-spinner>
      </div>

    </div>
    <h3 [hidden]='flexmode || officeJobs'>{{title}} <p *ngIf='version == 2' style="font-family:'Roboto'; font-size: 8px;">Under
        construction</p>
    </h3>
    <h3 [hidden]='!flexmode || officeJobs'>Flex Jobs</h3>
    <h3 [hidden]="!officeJobs">Office Jobs</h3>
    <!--<h1 style="text-align: center">Office Jobs</h1>  class="loadingText" -->

    <div class="d-flex align-items-center flex-mobile" style="flex-direction: column;">

      <!--
        <div>
        <span><label style="width: 100px;
          text-align: right;">Flex Jobs</label></span>
        <label class="switch" style="margin-left:22px;">
          <input type="checkbox" (click)='showFlexJobs()' [hidden]='flexmode'>
          <span class="slider round"></span>
        </label>
        </div>
      -->


      <div style="margin-top: 20px;" class="load-ev" *ngIf="auth.role==='TManager'">
      <span><label>Load everything</label></span>
      <label class="switch">
        <input type="checkbox" class="loadeverything" (click)='toggleLoadAll()' [hidden]='flexmode'>
        <span class="slider round"></span>
      </label>
      </div>

      <!--     <div style="margin-top: 20px;" class="load-ev" *ngIf="auth.role==='TManager' && loadFullList">
        <span><label>Hide Office jobs</label></span>
        <label class="switch">
          <input type="checkbox"  [checked]="isToggleOn" id='sitevisitfilter' class="loadeverything" (click)='filterJobsBySiteVisit()' [hidden]='flexmode'>
          <span class="slider round"></span>
        </label>
        </div>
        -->
 



      <div style="margin-top: 20px;" class="load-ev">
      <span><label>Search Friendly</label></span>
      <label class="switch">
        <input type="checkbox" [checked]="openFullDetails" (click)='toggleFullDetails()' [hidden]='flexmode'>
        <span class="slider round"></span>
      </label>
      </div>

      <div style="margin-top: 20px;" class="load-ev">
      <span><label>Scheduled only</label></span>
      <label class="switch">
        <input type="checkbox" id="scheduledonlyfilter" [checked]="scheduledOnly" (click)='toggleScheduledOnly()' [hidden]='flexmode'>
        <span class="slider round"></span>
      </label>
      </div>

      <!--
      <div style="margin-top: 20px;">
        <span><label style="width: 100px;
          text-align: right;">Office Jobs</label></span>
        <label class="switch" style="margin-left:22px;">
          <input type="checkbox" (click)="showOfficeJobs()">
          <span class="slider round"></span>
        </label>
        </div>
      -->

    </div>



  </div>

  <div class="shedule-wrapper" style="padding-bottom: 100px;">


    <div fxLayout="column" fxLayout.xs="column">
      <div class="d-flex flex-wrap">
        <div class="col-lg-6 col-12 px-3">
          <div class="my-alternate-theme calendarWidth" fxLayout="column" fxLayout.xs="column" style="color: black;">

            <mat-calendar [dateClass]="dateClass()" [(selected)]="sd" (selectedChange)="onSelectDate($event)"></mat-calendar>
            <!-- <a class="mobile-link-scroll" href="https://raterhelperv3.herokuapp.com/login">Can't Scroll? Click this to login again. </a> -->
            <p style="text-align: center;
            font-size: 15px;
            color: #959d9e;
            letter-spacing: 1px;"> Selected Date: {{scheduleDate || '(Today)'}}</p>


           <details *ngIf="auth.role==='TManager' && version === 1">
            <summary style="cursor: pointer;"> Select Regions</summary>
            <p style="color: #9e9e9e;">Scroll and select one or more</p>
              <div id = "selectDiv" *ngIf="auth.role==='TManager'">
                <select [(ngModel)]="selectedRegion" multiple (change)="setRegionFilterActive();processFilters();" style="width: 100%;
              color: #424242;
              background: #ffffff;
              height: 10em;
              padding: 0.5em;
              border: 0;
              float: right;
              scrollbar-color: black white;">
                  <option style="padding-top: 0.5em;
                    padding-bottom: 0.5em;
                    color: #424242;
                    font-weight: bold;
                    letter-spacing: 0.1em;
                    font-size: 1.25em;" *ngFor="let region of regions" [value]="region.region">
                    {{ region.region }}
                  </option>
                </select>
              </div>

          </details>

          <app-pto-panel *ngIf="(auth.role === 'TManager' || auth.role === 'Admin') && version === 1"
                         [employeeId]="employeeID"
                         [focusDate]="scheduleDate"
                         [rangeDays]="14"
                         title="Upcoming Time Off">
          </app-pto-panel>

            <p style="padding-top: 1em;
            font-size: 1em;
            font-weight: 600;
            color: #9e9e9e;font-size: 14px;"
            *ngIf='selectedRegion.length > 0'
            (click)="resetRegionFilter()">Clear Regions</p>


              <div>
              <button class = "batchEditButton" style="color:white;
              background: #1f1f1f9c;" (click)="doBatchEdit()" *ngIf="batchEditing">Batch Edit</button>

              <button class = "clearBatchButton" style="color: black;" (click)="clearBatch()" *ngIf="batchEditing">Clear</button>
              </div>



            <!--</mat-form-field>-->
          </div>
        </div>
        <div class="col-lg-6 col-12 px-3" style="align-self:center;">
          <div class="timeDisplay"  >
            <ng-container *ngIf="!allJobsLoading; else hoursLoading">
            <h5 style="font-weight: bold;
            letter-spacing: 1px;
            font-size: 18px;">{{ initialAllLoaded ? updateHours(hoursArray).jt : updateHours(jobsToday).jt }} </h5>

            <div id="hourtypedisplay" *ngIf ="auth.role != 'User'">
              <p style="font-size: 14px;
              font-weight: 400;
              margin-bottom: 0;
              color: #9c9c9c;"  (click)="setFilterJobType('QI'); processFilters()">{{ initialAllLoaded ? updateHours(hoursArray).qi : updateHours(jobsToday).qi }}</p>
              <p style="font-size: 14px;
              font-weight: 400;
              margin-bottom: 0;
              color: #9c9c9c;" (click)="setFilterJobType('MF');processFilters()">{{ initialAllLoaded ? updateHours(hoursArray).mf : updateHours(jobsToday).mf }}</p>
              <p style="font-size: 14px;
              font-weight: 400;
              color: #9c9c9c;" (click)="setFilterJobType('EG');processFilters()">{{ initialAllLoaded ? updateHours(hoursArray).eg : updateHours(jobsToday).eg }}</p>
            </div>
            </ng-container>
            <ng-template #hoursLoading>
              <div class="hours-loading"><mat-spinner diameter="22"></mat-spinner><span>Loading totals...</span></div>
            </ng-template>



            <div *ngIf="auth.role === 'TManager' && version === 1">
                <button style="background: rgba(255, 255, 255, 0.12);
                  border: none;
                  color: #9e9e9e;
                  padding-left: 0;" (click)="exportList()">Export</button>

                <p style="font-size: 14px;
                font-weight: 400;
                color: #fb0000;" *ngIf='filterjobtypeactive == true' (click)="resetJobTypeFilter()">Reset</p>
            </div>
          </div>
          
          <div class="search-container" *ngIf="auth.role==='TManager'">
          <i class="fa-solid fa-magnifying-glass" style="color:#8c8c8c"></i>
          <input class="search-input"  #empfil [(ngModel)]="employeeFilter" name="employeeFilter"  (blur)="blurTheSearch()"  (keyup)="search($event)">
          </div>


        </div>

        <div class="training-enrollment-banner" *ngIf="activeEnrollment && !flexmode && version != 2">
          <div class="training-banner-inner">
            <span class="training-banner-icon"><i class="fa-solid fa-graduation-cap"></i></span>
            <div class="training-banner-text">
              <span class="training-banner-label">Current course</span>
              <span class="training-banner-course">{{ activeEnrollment.course_name }}</span>
            </div>
            <div class="training-banner-progress-wrap">
              <div class="training-banner-progress-bar">
                <div class="training-banner-progress-fill" [style.width.%]="activeEnrollment.progress_pct || 0"></div>
              </div>
              <span class="training-banner-pct">{{ activeEnrollment.progress_pct || 0 }}%</span>
            </div>
            <a class="training-banner-link" [routerLink]="['/training/employee', activeEnrollment.id]">View training</a>
          </div>
        </div>

        <div *ngIf = "!daystarted" style="padding: 1rem;margin:auto">

          <button (click)="startDay(1)" class="sched-button">Start Work Day <i class="fa-solid fa-user-clock"></i></button>

          <button (click)="requestTraining()" class="sched-button" style="margin-left: 10px;">Request Training <i class="fa-solid fa-graduation-cap"></i></button>

          <p class="plink" style="font-size: 15px;
          font-weight: bold;
          padding: 12px;
          cursor: pointer;
          color: #959d9e;
          text-align: center;" (click)="viewTimeCard()">View Timecard</p>

        </div>

        <div *ngIf = "daystarted" style="display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100px;
        width: 95%;
        margin-top: 10px;">

          <div style="display: flex;">

            <div>
              <button (click)="startDay(2)" class="sched-button">End Work Day <i class="fa-regular fa-calendar-check"></i></button>
            </div>

            <div style="margin-left: 20px;">
            <button style="color: #959d9e;
            background: white;
            border: 0;
            height: 45px;
            font-size: 20px;" class="pauseButton" (click)="pauseDay()" [disabled]="areTimeButtonsDisabled"  *ngIf = "!isPaused && !isClockedIn"><i class="fa-solid fa-pause"></i> Pause</button>

            <button style="color: #add896;
            background: white;
            border: 0;
            height: 45px;
            font-size: 20px;" class="pauseButton" (click)="resumeDay()" [disabled]="areTimeButtonsDisabled" *ngIf = "isPaused"><i class="fa-solid fa-play"></i> Resume</button>
            </div>

          </div>

          <div>
            <p class="plink" style="font-size: 15px;
            font-weight: bold;
            padding: 12px;
            cursor: pointer;
            color: #959d9e;
            text-align: center;" (click)="viewTimeCard()">View Timecard</p>
          </div>

        </div>

      
      </div>

      <div>
        <button class="sched-button" *ngIf="!batchEditing" (click)="toggleBatchEditing()"> Batch Edit</button>
        <p *ngIf="batchEditing" (click)="toggleBatchEditing()" style="color: #3f3f3f;
        font-size: 15px;
        letter-spacing: 0.3px;"> Batch editing mode active. Click 'Clear' to exit. </p>
        </div>

    </div>




    <div>

      <p [hidden]='!flexmode'>Currently viewing flex jobs. Select a date to return to scheduled jobs.</p>

    </div>


    <div class="schedule-list d-flex flex-wrap" [hidden]='flexmode || version == 2' id="schedList">
      <ng-container *ngFor="let job of jobsToday; let indexOfElement = index; trackBy: trackByJobId">
      <div class="d-flex col-lg-6 p-3" *ngIf="isJobVisibleOnSchedule(job)" style="padding-bottom:20px;">
<!-- TRIGGERS INTERSECTION OBSERVER -->

        <mat-card
          [ngClass]="getStatusClass(job)"
          class='eq'  *ngIf="isLastVisibleScheduleJob(indexOfElement)" style='width:100%' #lastItem >
          <div [ngClass]="{'firstStopCard': job.firststop && job.job_status === 'Scheduled', 'tag57Card': jobHasTag(job, 57)}">
          <!--      <mat-card-header> -->
          <!--<div mat-card-avatar class="example-header-image"></div> -->
          <div class="card-header" [style.height]="tripTaskNotes(job).length ? 'auto' : '100px'">
            <h5 style="width:100%; height:100px;">
              <app-editable-textarea [data]='job.job_notes' style="height:100px;" (focusOut)='saveNotes($event, job)'></app-editable-textarea>
            </h5>
            <div *ngIf="tripTaskNotes(job).length" class="trip-task-notes">
              <div *ngFor="let n of tripTaskNotes(job)">
                <b>[{{ n.jobtype }}]</b> <span style="white-space: pre-line;">{{ n.job_notes }}</span>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="col-12 shedule-title">
              <h3 class="user-name">{{ job.employee_name }}</h3>
              <div class="action-btn-wrapper">

                  <button (click)="openJobInNewTab(job)"><i class="fa-solid fa-truck"></i></button>
                  <button class="clock" *ngIf="(job.clockedin == false || job.clockedin == null || !isParticipant(job.participants, employeeID)) && !isPaused" [disabled]="areTimeButtonsDisabled" (click)="updateStartTimeNew(job)"><i class="fa fa-solid fa-clock"></i>Clock In</button>
                  <button class="clock active" *ngIf="job.clockedin == true || isParticipant(job.participants,employeeID)" [disabled]="areTimeButtonsDisabled" (click)="updateEndTimeNew(job)"><i class="fa fa-solid fa-clock"></i>Clock Out </button>
                <!-- <button (click)='openJobInNewTab(job)'>
                  <fa-icon [icon]="fahardhat"></fa-icon> Forms
                </button> -->
                <button (click)="openDialogSequence(job)">
                  <i class="fa-solid fa-clipboard-list"></i> Form
                </button>
              </div>
            </div>
            <div class="d-flex flex-wrap col-12">
              <div class="flex-column col-lg-6 px-3">

                <div class="flex-card-item" style="height:3em; text-align: left">
                  <ng-container *ngIf="selectActive(job, 'conf'); else confText1">
                  <mat-form-field appearance="outline">
                    <!--<mat-label>{{job.conf_status}}</mat-label>-->
                    <mat-select appAutoOpenSelect [class]=getConfClass(job) style="font-size:18px !important;margin-left: -1.4rem;"  floatlLabel="never"
                      placeholder="Confirmation status" [compareWith]="compareConfStatus" (selectionChange)='updateStatus($event, job, confstat.value)' #confstat
                      [(ngModel)]='job.conf_status'>
                      <mat-option value="Builder confirmed">Builder Confirmed</mat-option>
                      <mat-option value="Not confirmed, call first">Not confirmed, call first</mat-option>
                      <mat-option value="Not ready">Not ready</mat-option>
                      <mat-option value="Reschedule">Reschedule</mat-option>
                    </mat-select>
                  </mat-form-field>
                  </ng-container>
                  <ng-template #confText1>
                    <div class="lazy-select lazy-select-plain" [ngClass]="getConfClass(job)" (click)="activateSelect(job, 'conf')"><span>{{ job.conf_status || 'Confirmation status' }}</span><span class="lazy-select-arrow"></span></div>
                  </ng-template>
                </div>

                 <div class="flex-card-item">
                  <h4 class="false-link"
                    style="text-align: left;
                    cursor: pointer;
                    font-weight: bold;
                    font-family: 'Roboto';
                    color: #424242;
                    letter-spacing: 0.6px;
                    font-size: 18px;"
                    (click)="subdivisionPopup(job)">{{ job.subdivision_name }} - {{ job.lot }}</h4>

                  <div (click)="toggleLinkData(indexOfElement)"
                    [ngClass]="{active: toggleItem[indexOfElement] == indexOfElement && toggleLinkData}"
                    class="collapse-link">
                    <p style="text-align: left;
                    color: #8c8c8c;
                    font-size: 18px;line-height: 1.2;
                    margin-bottom: 0px;">{{job.street_address}}
                    {{job.city}},{{job.state}} {{job.zip}}</p> <i class="fa fa-solid fa-angle-down"></i></div>
                  </div>

                <div *ngIf="openFullDetails || toggleItem[indexOfElement] == true" style="color: #3f3f3f;
                line-height: 1;">
                  <div class="flex-card-item estimated-time">
                    <p>Scope: {{job.scope}}</p>
                  </div>
                  <div style="display: flex;
                    justify-content: space-between;
                    align-items: center;" id="nameContainer">
                    <div class="flex-card-item estimated-time" style="font-size: 14px;
                    font-weight: 600;">
                      <p style="margin-bottom: 0 !important;">{{job.name}}</p>
                    </div>
                    <div class="flex-card-item estimated-time" style="font-size: 14px;
                    font-weight: 600;">
                      {{job.contact_phone}}
                    </div>
                  </div>

                  <div *ngIf="!(auth.role === 'Sub-C') " class="flex-card-item shedule-email">
                    <p style="font-size: 12px;
                    margin-bottom: 0;text-align:left;letter-spacing:0.3px;">{{job.contact_e_mail}} - {{job.contacts}}</p>
                  </div>

                  <div *ngIf="job.consultant_name" style="margin-top: .5em;">
                    <div style="display: flex;
                    justify-content: space-between;
                    align-items: center;">
                      <div class="flex-card-item estimated-time" style="font-size: 14px;
                      font-weight: 600;">
                        <p style="margin-bottom: 0 !important;">Consultant: {{job.consultant_name}}</p>
                      </div>
                      <div class="flex-card-item estimated-time" style="font-size: 14px;
                      font-weight: 600;">
                        <a *ngIf="job.consultant_phone" href="tel:{{job.consultant_phone}}">{{job.consultant_phone}}</a>
                      </div>
                    </div>
                    <div *ngIf="job.consultant_email" class="flex-card-item shedule-email">
                      <p style="font-size: 12px;
                      margin-bottom: 0;text-align:left;letter-spacing:0.3px;"><a href="mailto:{{job.consultant_email}}">{{job.consultant_email}}</a></p>
                    </div>
                  </div>
                </div>

                <div class="flex-card-item estimated-time" [hidden]="job.flex_start_date == null">
                  Start date: <p>[{{ job.flex_start_date }}]</p>
                </div>


              </div>

              <div class="flex-column col-lg-6 px-3">

                <div style="padding-top: .25em;">
                  <div class="flex-card-item estimated-time">
                    <p style="text-align:left;margin-bottom: 0;color: #3f3f3f;
                    font-weight: bold;"><span *ngIf="!(auth.role === 'Sub-C')">{{job.customer_name}} -</span> {{job.customer_jobtype}}</p>
                  </div>
                  <div *ngIf="job.istrip" class="flex-card-item estimated-time">
                    <p style="text-align:left; margin-bottom: 0; font-weight: bold; color: #424242; letter-spacing: 1px;">TRIP</p>
                  </div>
                  <div class="flex-card-item estimated-time">
                    <p style="text-align: left;
                    margin-bottom: 0px;
                    letter-spacing: 0.3px;
                    font-size: 14px;
                    color: #3f3f3f;">Estimated time: {{job.estimatedtime}}</p>
                  </div>
                  <div class="flex-card-item esitmated-time">
                    <div><p class="job_id_text" (click)="copyText(job.job_id)">
                    Job_ID: {{job.job_id}} </p></div>
                    <div><p *ngIf= "job.permit_no" class="permit_id_text">Permit #{{job.permit_no}}</p></div>
                  </div>
                </div>

                <div *ngIf="!job.istrip">

                <div class="flex-card-item" style="margin-top: 1.15em;padding-bottom: 0 !important;">
                  <ng-container *ngIf="selectActive(job, 'status'); else statusText1">
                  <mat-form-field appearance="outline" style="height:2em;margin-left: 0.25em;padding-bottom: 0;">
                    <mat-label>{{job.job_status?.trim()}}</mat-label>
                    <mat-select appAutoOpenSelect  #jobstatus (selectionChange)="updateJobStatus($event, job)"
                    [(ngModel)]='job.job_status' style="margin-left: -1.4rem;font-size: 18px !important;" >
                      <mat-option *ngFor = "let status of (
                        isComplianceStatusJobtype(job.customer_jobtype)
                      ? reportStati : stati)" [value] = "status.value">
                    {{status.viewValue}}
                      </mat-option>
                      <mat-option *ngIf="job.job_status === 'Fail-RIS'" value="Fail-RIS" disabled>Fail - RIS</mat-option>
                    </mat-select>
                  </mat-form-field>
                  </ng-container>
                  <ng-template #statusText1>
                    <div class="lazy-select lazy-select-plain" (click)="activateSelect(job, 'status')"><span>{{ job.job_status?.trim() }}</span><span class="lazy-select-arrow"></span></div>
                  </ng-template>
                </div>

                <!-- <p *ngIf="job.job_status == 'Fail' ">Select one or more fail reasons below: </p> -->
                <div style="padding-top: 4em;"><button *ngIf="job.job_status == 'Fail'" style="background: white;
                color: #8cc63f;
                cursor: pointer;
                border: 1px solid lightgrey;
                border-radius: 5px;
                position: relative; 
                z-index: 1;" (click)="openFailReasonsPopup(job)"> View / Edit Fail reasons</button></div>
                </div>


                <div *ngIf="job.istrip" style="margin: 1em; margin-left: -1em;">
                  <button
                    [style.background]="job.job_status?.trim() === 'Complete' ? '#8cc63f' : 'white'"
                    [style.color]="job.job_status?.trim() === 'Complete' ? 'white' : '#8cc63f'"
                    [style.borderColor]="job.job_status?.trim() === 'Complete' ? '#8cc63f' : 'lightgrey'"
                    style="border: 1px solid lightgrey; border-radius: 5px;"
                    (click)="openTripStatuses(job)">
                    <span *ngIf="job.job_status?.trim() === 'Complete'" style="margin-right: 4px;">&#10003;</span>View Tasks/Statuses</button>
                </div>

  <!--
                <div class="flex-card-item" style="padding-top: -5px;" *ngIf="job.job_status == 'Fail' "> -->
                  <!--
                  <div *ngFor="let fr of job.failreason">
                    <p>{{fr.failreason}}</p>
                  </div>
                  -->
                  <!--
                  <mat-form-field style="margin: 0px; color: black;">
                    <mat-select (selectionChange)="updateFailReason($event, job)" multiple [(ngModel)]='job.failreason'>
                      <mat-option *ngFor="let reason of failreasons" value="{{reason.failreason}}">{{reason.failreason}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              -->


              <!--
                <div class="debugInfo">
                <p style="margin-right: 5px">PR: {{job.locpics_id}}</p>
                <p>RF: {{job.form_id}}</p>
                </div>
-->

                <div style="color: #a0a0a0;" *ngIf="batchEditing">
                  Batch Edit
                  <mat-checkbox #checkbox style="padding-left: 5px; padding-right: 7px;"  (change)="getCheckedIndexes(job)" ></mat-checkbox>
                </div>
              </div>
            </div>

            <div>
              <div class="flex-card-item" [hidden]="job.flex_start_date != null">
                <button *ngIf="job.isaudit" class="card-button" mat-raised-button (click)='sendAuditEmail(job.job_id, job.location_id)'>Email</button>
                <button class="card-button" mat-raised-button (click)='openDrainCam(job)'
                  *ngIf="job.customer_jobtype.includes('Drain')">Drain Cam</button>
                <button class="card-button" mat-raised-button (click)='openSafetyInspection(job)'
                  *ngIf="job.customer_jobtype.includes('Safety')">Safety Inspection</button>
                <!-- <button mat-raised-button style="background-color: skyblue" (click)='dispatchQI(job)'>Dispatch</button> -->
                <button   [ngClass]="{
                  'email-button-green': emailSentStatus[job.job_id],
                  'email-button-default': !emailSentStatus[job.job_id]
                }" *ngIf="!job.isaudit && !job.email_sent && !(job.customer_jobtype.toLowerCase().includes('qi'))" class="card-button" mat-raised-button (click)='onEmailClick(job)'>Email</button>
                <button style="background:#8cc63f;color: white;" *ngIf="!job.isaudit && job.email_sent && !(job.customer_jobtype.toLowerCase().includes('qi'))" class="card-button" mat-raised-button (click)='onEmailClick(job)'>Email</button>
                <button *ngIf="job.customer_jobtype.includes('NGBS') || job.customer_jobtype.includes('ESMFNC')" class="card-button" mat-raised-button (click)='comingsoon()'>Send Report</button>
                <button class="card-button" mat-raised-button (click)='showPhotosModal(job)'>Photos</button>

                <button class="card-button" mat-raised-button (click)='openEditJob(job,indexOfElement)'>Edit</button>
                <!--<button class="card-button" [hidden]="!job.job_status.toLowerCase().includes('comp') " mat-raised-button
                  (click)='sendReviewEmail(job)'>Send For a Review</button>-->
                <!--<button class="card-button" mat-raised-button>Reschedule</button>-->
                <button class="card-button" mat-raised-button (click)='additionalWork(job)'>Things</button>
                <button *ngIf="canShowOnOurWay(job)" class="card-button oow-button" [ngClass]="{'email-button-green': isOowPressed(job)}" mat-raised-button (click)='onOurWay(job)'>On Our Way</button>
              </div>
            </div>

          </div>

          <mat-card-content style="width:95%">

          </mat-card-content>

          </div>
        </mat-card>

<!--   THE DEFAULT ONE-->
        <mat-card
        [ngClass]="getStatusClass(job)"
        class='eq' *ngIf="!isLastVisibleScheduleJob(indexOfElement)" style='width:100%'>
        <div [ngClass]="{'firstStopCard': job.firststop && job.job_status === 'Scheduled', 'tag57Card': jobHasTag(job, 57)}">

          <!--      <mat-card-header> -->
          <!--<div mat-card-avatar class="example-header-image"></div> -->
          <div class="card-header" [style.height]="tripTaskNotes(job).length ? 'auto' : '100px'">
            <h5 style="width:100%; height:100px;">
              <app-editable-textarea [data]='job.job_notes' style="height:100px;" (focusOut)='saveNotes($event, job)'></app-editable-textarea>
            </h5>
            <div *ngIf="tripTaskNotes(job).length" class="trip-task-notes">
              <div *ngFor="let n of tripTaskNotes(job)">
                <b>[{{ n.jobtype }}]</b> <span style="white-space: pre-line;">{{ n.job_notes }}</span>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="col-12 shedule-title">
              <h3 class="user-name">{{ job.employee_name }}</h3>
              <div class="action-btn-wrapper">
                <!--<button class="clock" [ngClass]="job.clockedin == false  || job.clockedin == null? '' : 'active'"
                  (click)="job.clockedin = true ? updateEndTime(job) : updateStartTime(job)"><i class="fa fa-solid fa-clock"></i>{{job.clockedin == false ||
                  job.clockedin == null? 'Clock In':'Clock Out'}}</button> -->

                  <div style="padding-right:1em;display:flex;" *ngIf="version == 2">
                  <div *ngIf="job.folderid != null" style="padding-right:1em;">
                      <a target="_blank" [href]=gotoGDrive(job) >
                              <fa-icon [icon]="fagoogle"  style= 'font-size: 2em; color:#8cc63f;'></fa-icon>
                      </a>
                    </div>
                    <div *ngIf="job.ekotrope_id != null"><a [href]="gotoEko(job)" target = "_blank">
                    <fa-icon style="color: #8cc63f;font-size:2em;" title="View Ekotrope file" [icon]="faEko"></fa-icon>
                    </a>
                    </div>
                  </div>

                  <button (click)="openJobInNewTab(job)"><i class="fa-solid fa-truck"></i></button>
                  <button class="clock" *ngIf="(job.clockedin == false || job.clockedin == null || !isParticipant(job.participants, employeeID)) && !isPaused" [disabled]="areTimeButtonsDisabled" (click)="updateStartTimeNew(job)"><i class="fa fa-solid fa-clock"></i>Clock In</button>
                  <button class="clock active" *ngIf="isParticipant(job.participants,employeeID)" [disabled]="areTimeButtonsDisabled"  (click)="updateEndTimeNew(job)"><i class="fa fa-solid fa-clock"></i>Clock Out </button>
                <!-- <button (click)='openJobInNewTab(job)'>
                  <fa-icon [icon]="fahardhat"></fa-icon> Forms
                </button> -->
                <button (click)="openDialogSequence(job)">
                  <i class="fa-solid fa-clipboard-list"></i> Form
                </button>
              </div>
            </div>
            <div class="d-flex flex-wrap col-12">
              <div class="flex-column col-lg-6 px-3">
                <div class="flex-card-item" style="text-align: left">
                  <ng-container *ngIf="selectActive(job, 'conf'); else confText2">
                  <mat-form-field appearance="outline" style="height:3em">
                    <mat-select appAutoOpenSelect [class]=getConfClass(job) style="font-size:18px !important; margin-left: -1.4rem;" floatlLabel="never"
                      placeholder="Confirmation status" [compareWith]="compareConfStatus" (selectionChange)='updateStatus($event, job, confstat.value)' #confstat
                      [(ngModel)]='job.conf_status'>
                      <mat-option value="Builder confirmed">Builder Confirmed</mat-option>
                      <mat-option value="Not confirmed, call first">Not confirmed, call first</mat-option>
                      <mat-option value="Not ready">Not ready</mat-option>
                      <mat-option value="Reschedule">Reschedule</mat-option>
                    </mat-select>
                  </mat-form-field>
                  </ng-container>
                  <ng-template #confText2>
                    <div class="lazy-select lazy-select-plain" [ngClass]="getConfClass(job)" (click)="activateSelect(job, 'conf')"><span>{{ job.conf_status || 'Confirmation status' }}</span><span class="lazy-select-arrow"></span></div>
                  </ng-template>
                </div>

                <div class="flex-card-item">
                  <h4 class="false-link"
                    style="text-align: left;
                    cursor: pointer;
                    font-weight: bold;
                    font-family: 'Roboto';
                    color: #424242;
                    letter-spacing: 1px;
                    font-size: 18px;"
                    (click)="subdivisionPopup(job)">{{ job.subdivision_name }} - {{ job.lot }}</h4>
                  <div (click)="toggleLinkData(indexOfElement)"
                    [ngClass]="{active: toggleItem[indexOfElement] == indexOfElement && toggleLinkData}"
                    class="collapse-link">
                    <p style="text-align: left;
                    color: #8c8c8c;
                    font-size: 18px;line-height: 1.2;
                    margin-bottom: 0px;">{{job.street_address}}
                    {{job.city}},{{job.state}} {{job.zip}}</p> <i class="fa fa-solid fa-angle-down"></i></div>
                </div>

                <div *ngIf="openFullDetails || toggleItem[indexOfElement] == true" style="color: #3f3f3f;
                line-height: 1;">
                  <div class="flex-card-item estimated-time">
                    <p>Scope: {{job.scope}}</p>
                  </div>
                  <div style="display: flex;
                    justify-content: space-between;
                    align-items: center;" id="nameContainer">
                    <div class="flex-card-item estimated-time" style="font-size: 14px;
                    font-weight: 600;">
                      <p style="margin-bottom: 0 !important;">{{job.name}}</p>
                    </div>
                    <div class="flex-card-item estimated-time" style="font-size: 14px;
                    font-weight: 600;">
                      {{job.contact_phone}}
                    </div>
                  </div>

                  <div *ngIf="!(auth.role === 'Sub-C') " class="flex-card-item shedule-email">
                    <p style="font-size: 12px;
                    margin-bottom: 0;text-align:left;letter-spacing:0.3px;">{{job.contact_e_mail}} - {{job.contacts}}</p>
                  </div>

                  <div *ngIf="job.consultant_name" style="margin-top: .5em;">
                    <div style="display: flex;
                    justify-content: space-between;
                    align-items: center;">
                      <div class="flex-card-item estimated-time" style="font-size: 14px;
                      font-weight: 600;">
                        <p style="margin-bottom: 0 !important;">Consultant: {{job.consultant_name}}</p>
                      </div>
                      <div class="flex-card-item estimated-time" style="font-size: 14px;
                      font-weight: 600;">
                        <a *ngIf="job.consultant_phone" href="tel:{{job.consultant_phone}}">{{job.consultant_phone}}</a>
                      </div>
                    </div>
                    <div *ngIf="job.consultant_email" class="flex-card-item shedule-email">
                      <p style="font-size: 12px;
                      margin-bottom: 0;text-align:left;letter-spacing:0.3px;"><a href="mailto:{{job.consultant_email}}">{{job.consultant_email}}</a></p>
                    </div>
                  </div>
                </div>

                <div class="flex-card-item estimated-time" [hidden]="job.flex_start_date == null">
                  Start date: <p>[{{ job.flex_start_date }}]</p>
                </div>


              </div>

              <div class="flex-column col-lg-6 px-3">

                <div style="padding-top: .25em;">
                  <div class="flex-card-item estimated-time">
                    <p style="text-align:left;margin-bottom: 0;color: #3f3f3f;
                    font-weight: bold;"><span *ngIf="!(auth.role === 'Sub-C')">{{job.customer_name}} -</span> {{job.customer_jobtype}}</p>
                  </div>
                  <div *ngIf="job.istrip" class="flex-card-item estimated-time">
                    <p style="text-align:left; margin-bottom: 0; font-weight: bold; color: #424242; letter-spacing: 1px;">TRIP</p>
                  </div>
                  <div class="flex-card-item estimated-time">
                    <p style="text-align: left;
                    margin-bottom: 0px;
                    letter-spacing: 0.3px;
                    font-size: 14px;
                    color: #3f3f3f;">Estimated time: {{job.estimatedtime}}</p>
                  </div>
                  <div class="flex-card-item esitmated-time">
                    <div><p class="job_id_text" (click)="copyText(job.job_id)">
                    Job_ID: {{job.job_id}} </p></div>
                    <div><p *ngIf= "job.permit_no" class="permit_id_text">Permit #{{job.permit_no}}</p></div>
                  </div>
                </div>

                <!--
                <div class="flex-card-item" style="margin-top: 1.5em;">
                  <mat-form-field appearance="outline" style="height:2em;margin-left: 0.25em;">
                    <mat-label>{{job.job_status?.trim()}}</mat-label>
                    <mat-select #jobstatus (selectionChange)="updateJobStatus($event, job)"
                      [(ngModel)]='job.job_status' style="margin-left: -1.4rem;font-size: 18px !important;">
                      <mat-option style="margin-bottom: 40px;" value="Pass">Pass </mat-option>
                      <mat-option style="margin-bottom: 40px;" value="Fail">Fail</mat-option>
                      <mat-option style="margin-bottom: 40px;" value="Fail-NR">Fail - No Reschedule</mat-option>
                      <mat-option value="Canceled">Canceled</mat-option>
                      <mat-option value="Complete">Complete</mat-option>
                      <mat-option value="UnderRev">Under Review</mat-option>
                      <mat-option value="On hold">On hold</mat-option>
                      <mat-option value="EPO hold">EPO Hold</mat-option>
                      <mat-option value="Scheduled">Scheduled</mat-option>
                      <mat-option *ngIf="job.job_status === 'Fail-RIS'" value="Fail-RIS" disabled>Fail - RIS</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div> -->
                

                <div *ngIf="!job.istrip">
                <div class="flex-card-item" style="margin-top: 1.5em;">
                  <ng-container *ngIf="selectActive(job, 'status'); else statusText2">
                  <mat-form-field appearance="outline" style="height:2em;margin-left: 0.25em;">
                    <mat-label>{{job.job_status?.trim()}}</mat-label>
                    <mat-select appAutoOpenSelect  #jobstatus (selectionChange)="updateJobStatus($event, job)"
                    [(ngModel)]='job.job_status' style="margin-left: -1.4rem;font-size: 18px !important;" >
                      <mat-option *ngFor = "let status of (
                        isComplianceStatusJobtype(job.customer_jobtype)
                      ? reportStati : stati)" [value] = "status.value">
                    {{status.viewValue}}
                      </mat-option>
                      <mat-option *ngIf="job.job_status === 'Fail-RIS'" value="Fail-RIS" disabled>Fail - RIS</mat-option>
                    </mat-select>
                  </mat-form-field>
                  </ng-container>
                  <ng-template #statusText2>
                    <div class="lazy-select lazy-select-plain" (click)="activateSelect(job, 'status')"><span>{{ job.job_status?.trim() }}</span><span class="lazy-select-arrow"></span></div>
                  </ng-template>
                </div>

                <!-- <p *ngIf="job.job_status == 'Fail' ">Select one or more fail reasons below: </p> -->
                <div>
                <button *ngIf="job.job_status == 'Fail'" style="background: white;
                color: #8cc63f;
                cursor: pointer;
                border: 1px solid lightgrey;
                border-radius: 5px;
                position: relative; 
                z-index: 1;" (click)="openFailReasonsPopup(job)"> View / Edit Fail reasons</button></div>

                </div>
                <div *ngIf="job.istrip" style="margin: 1em; margin-left: -1em;">
                  <button
                    [style.background]="job.job_status?.trim() === 'Complete' ? '#8cc63f' : 'white'"
                    [style.color]="job.job_status?.trim() === 'Complete' ? 'white' : '#8cc63f'"
                    [style.borderColor]="job.job_status?.trim() === 'Complete' ? '#8cc63f' : 'lightgrey'"
                    style="border: 1px solid lightgrey; border-radius: 5px;"
                    (click)="openTripStatuses(job)">
                    <span *ngIf="job.job_status?.trim() === 'Complete'" style="margin-right: 4px;">&#10003;</span>View Tasks/Statuses</button>
                </div>

                <div style="color: #a0a0a0;" *ngIf="batchEditing">
                  Batch Edit
                  <mat-checkbox #checkbox style="padding-left: 5px; padding-right: 7px;"  (change)="getCheckedIndexes(job)" ></mat-checkbox>
                </div>


              </div>
            </div>

            <div style="margin-top: 1em;">
              <div class="flex-card-item" [hidden]="job.flex_start_date != null">
                <button *ngIf="job.isaudit" class="card-button" mat-raised-button (click)='sendAuditEmail(job.job_id, job.location_id)'>Email</button>
                <button class="card-button" mat-raised-button (click)='openDrainCam(job)'
                  *ngIf="job.customer_jobtype.includes('Drain')">Drain Cam</button>
                <button class="card-button" mat-raised-button (click)='openSafetyInspection(job)'
                  *ngIf="job.customer_jobtype.includes('Safety')">Safety Inspection</button>
                <!-- <button mat-raised-button style="background-color: skyblue" (click)='dispatchQI(job)'>Dispatch</button> -->
                <button   [ngClass]="{
                  'email-button-green': emailSentStatus[job.job_id],
                  'email-button-default': !emailSentStatus[job.job_id]
                }" *ngIf="!job.isaudit && !job.email_sent && !(job.customer_jobtype.toLowerCase().includes('qi'))" class="card-button" mat-raised-button (click)='onEmailClick(job)'>Email</button>
                <button style="background:#8cc63f;color: white;" *ngIf="!job.isaudit && job.email_sent && !(job.customer_jobtype.toLowerCase().includes('qi'))" class="card-button" mat-raised-button (click)='onEmailClick(job)'>Email</button>
                <button *ngIf="job.customer_jobtype.includes('NGBS') || job.customer_jobtype.includes('ESMFNC')" class="card-button" mat-raised-button (click)='comingsoon()'>Send Report</button>
                <button class="card-button" mat-raised-button (click)='showPhotosModal(job)'>Photos</button>
                <button class="card-button" mat-raised-button (click)='openEditJob(job,indexOfElement)'>Edit</button>
                <!--<button class="card-button" [hidden]="!job.job_status.toLowerCase().includes('comp') " mat-raised-button
                  (click)='sendReviewEmail(job)'>Send For a Review</button>-->
                <!-- <button class="card-button" mat-raised-button>Resched.</button> -->
                <button class="card-button" mat-raised-button (click)='additionalWork(job)'>Things</button>
                <button *ngIf="canShowOnOurWay(job)" class="card-button oow-button" [ngClass]="{'email-button-green': isOowPressed(job)}" mat-raised-button (click)='onOurWay(job)'>On Our Way</button>
              </div>
            </div>

          </div>


          <mat-card-content style="width:95%">


            <!--
            <div fxLayout="column" fxLayout.xs ="column">
              <h3 class="h3altered">{{ job.customer_jobtype }}</h3>
              <i style="margin: 0px;">{{ job.street_address}} {{job.city}}, {{job.state}}</i>
              <p style="margin: 0px;">{{ job.name }}</p>
              <p style="margin: 0px;">{{ job.phone }}</p>
              <p style="margin: 0px;">{{ job.contact_e_mail}}</p>
              <p style="margin: 0px;">Permit#: {{job.permit_no}}</p>
              <em>{{job.form_id}}</em>
            </div>

              <mat-form-field style="margin: 0px;">
                  <mat-label>{{job.job_status}}</mat-label>
                  <mat-select>
                    <mat-option value= "Pass">Pass </mat-option>
                    <mat-option value= "Fail">Fail</mat-option>
                    <mat-option value= "Complete">Complete </mat-option>
                    <mat-option value= "Scheduled">Scheduled</mat-option>

                  </mat-select>
              </mat-form-field>
            -->

          </mat-card-content>

        </div>
      </mat-card>
      <br>

      </div>
      </ng-container>

    </div>

    <p style="text-align: center;
    font-size: 24px; ;" *ngIf = '(loadingScroll == true && !lastPageLoaded && initialAllLoaded && !filterActivated && !loadFullList) && jobsToday.length > 0 '>Loading more...</p>

    <p style="text-align: center;
    font-size: 24px; ;" *ngIf = 'lastPageLoaded || !initialAllLoaded || filterActivated || loadFullList || jobsToday.length == 0 '> End of List</p> <p *ngIf='this.employeeFilter' style="text-align:center;">(Searching for '{{employeeFilter}}.' Clear filter for more results )</p>


  </div>

  </div>
